import {
    CloseOutlined,
    DeleteFilled,
    EditFilled,
    PlusOutlined,
    SaveFilled,
    SearchOutlined,
    PrinterFilled,
    ClearOutlined,
    SaveOutlined
} from "@ant-design/icons";
import { Button, Popconfirm, Row, Space, Table } from "antd";
import { array, bool, element, func, string } from "prop-types";
import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BUTTON_SIZE, TABLE_SIZE } from "../../common/ThemeConstants";
import FormButton from "../general/FormButton";
import FormContainer from "../general/FormContainer";
import FormModal from "../general/FormModal";
import "./BasicFormComponent.css";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import Title from "antd/lib/typography/Title";

const BasicModalFormComponent = (props) => {
    const {
        reset,
        handleReset,
        handleSave,
        formTitle,
        searchPanel,
        searchSubmit,
        formPanel,
        tableColumn = [],
        tableRows = [],
        tableLoading = false,
        onFormSave,
        formWidth,
        hideAction = false,
        hideEdit = false,
        hideDelete = false,
        actionID,
        editRow,
        deleteRow,
        formLoading,
        fields,
        onFormClose,
        onUpdate,
        onFormOpen,
        hideAddButton = false,
        hideSearchButton = false,
        crudTitle,
        showSubmit = false,
        submitForm,
        submitFormLoading,
        disableSaveAndSubmit = false,
        disableForm = false,
        report = false,
        viewReport,
        componentRefPrint,
        isCancel = false,
        onCancel,
        setIsDrawerOpen = () => { }, // Default to an empty function
        externalCloseTrigger = false, // Prop to trigger external close
        onPaginationChange, // Custom pagination handler
        paginationConfig, // Pagination configuration object
    } = props;

    const FeatureArray = useSelector(
        (state) => state.MenuFeatureReducer?.MenuFeature?.[0]?.Features
    );
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const authReducerList = useSelector(a => a.authReducer);

    const toggleDrawer = () => {

        setIsUpdate(!isUpdate);
        setVisible(!visible);
        if (setIsDrawerOpen) {
            setIsDrawerOpen(prev => !prev);
        }
    };

    const handleUpdateAction = (id) => {
        editRow && editRow((x) => (x = id));
        toggleDrawer();
    };

    const handleDeleteAction = (id, record) => {
        deleteRow && deleteRow(id, record);
    };

    const FeatureExists = (array, value) => {

        if (!Array.isArray(array)) {
            return true;
        }

        if (array[0]?.FeatureExist === false || array.length === 0) {
            return true;
        }
        return array.includes(value.toUpperCase());
    }

    useEffect(() => {
        if (externalCloseTrigger && visible) {
            closeForm();
        }

    }, [externalCloseTrigger, visible]);

    useEffect(() => {

        !hideAction &&
            tableColumn &&
            tableColumn.push({
                title: "Action",
                key: "action",
                width: 120,
                render: (record) => {
                    return (
                        <Space size="middle">
                            {!hideEdit && (
                                FeatureExists(FeatureArray, "edit") && (
                                    <Button
                                        type="text"
                                        onClick={() => handleUpdateAction(record[actionID])}
                                        icon={<EditFilled className="blueIcon" />}
                                    ></Button>
                                )
                            )}
                            {!hideDelete && (
                                FeatureExists(FeatureArray, "delete") && (
                                    <Popconfirm
                                        title="Are you surely want to delete this row?"
                                        onConfirm={() => handleDeleteAction(record[actionID], record)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button
                                            type="text"
                                            icon={<DeleteFilled className="redIcon" />}
                                        ></Button>
                                    </Popconfirm>
                                )
                            )}
                            {report && (
                                <ReactToPrint content={() => componentRefPrint.current}>
                                    <PrintContextConsumer>
                                        {({ handlePrint }) => (
                                            <Button
                                                type="text"
                                                onClick={() => viewReport(record, handlePrint)}
                                                icon={<PrinterFilled className="blueIcon" />}
                                            ></Button>
                                        )}
                                    </PrintContextConsumer>
                                </ReactToPrint>
                            )}
                        </Space>
                    );
                },
            });
        return () => {
            tableColumn.pop();
        };
    }, []);

    const handlePagination = (paginationInfo, filters, sorter) => {
        if (onPaginationChange) {
            onPaginationChange(paginationInfo, filters, sorter);
        }
        // // console.log(pagination);
    };

    const closeForm = () => {
        fields &&
            dispatch({
                type: "RESET_FORM_FIELDS",
                payload: { initialValue: fields },
            });
        if (isCancel) onCancel();
        toggleDrawer();
        onFormClose && onFormClose();
    };

    const handleFormSubmit = (e) => {

        e.preventDefault();
        if (!disableSaveAndSubmit) {
            if (isUpdate) {
                onFormSave(e, 3, isSubmit);
                onUpdate && onUpdate();
            } else {
                onFormSave(e, 2, isSubmit);
            }
        }

    };

    const handleSaveClick = (e) => {
        e.preventDefault();
        setIsSubmit(false);
        handleFormSubmit({ preventDefault: () => { } });
    };

    const handleSubmitClick = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        handleFormSubmit({ preventDefault: () => { } });
    };

    const modalFooter = (
        <Space>
            <FormButton
                title="Cancel"
                type="default"
                color="gray"
                icon={<CloseOutlined />}
                size={BUTTON_SIZE}
                colSpan={2}
                onClick={closeForm}
            />
            {!disableSaveAndSubmit && (
                <>
                    <FormButton
                        title={isUpdate ? "Update" : "Save"}
                        type="primary"
                        icon={<SaveFilled />}
                        size={BUTTON_SIZE}
                        colSpan={2}
                        loading={formLoading}
                        disabled={disableSaveAndSubmit}
                        onClick={handleSaveClick}
                    />
                    {showSubmit && (
                        <FormButton
                            title={"Submit"}
                            type="default"
                            icon={<SaveFilled />}
                            size={BUTTON_SIZE}
                            colSpan={2}
                            onClick={handleSubmitClick}
                            loading={submitFormLoading}
                            disabled={disableSaveAndSubmit}
                        />
                    )}
                </>
            )}
        </Space>
    );

    const formInnerComponent = (
        <>
            {/* <div className="formModalHeader">
                <h2>{`${isUpdate ? "Update" : "New"} ${crudTitle ? crudTitle : formTitle}`}</h2>
            </div> */}
            <div className="formModalBody w-full">{formPanel}</div>
        </>
    );

    return (
        <div style={{ margin: 5 }}>
            <Title level={3} style={{ color: "#017971" }}>
                {formTitle}
            </Title>
            <div
                style={{
                    background: "white",
                    padding: 15,
                    boxShadow: "0 0 5px lightgray",
                    borderRadius: 2,
                }}
            >
                {searchPanel && (
                    <FormContainer
                        rowStyle={{ alignItems: "flex-end" }}
                        onSubmit={searchSubmit}
                    >
                        {searchPanel}
                        {!hideSearchButton && (
                            <Fragment>
                                <FormButton
                                    title="Search"
                                    type="primary"
                                    size={BUTTON_SIZE}
                                    colSpan={2}
                                    htmlType="submit"
                                    icon={<SearchOutlined />}
                                />
                                {reset && (
                                    <FormButton
                                        title="Reset"
                                        type="default"
                                        size={BUTTON_SIZE}
                                        colSpan={2}
                                        htmlType="button"
                                        onClick={handleReset}
                                        style={{ marginLeft: '0px', color: 'white' }}
                                        icon={<ClearOutlined />}
                                    />
                                )}
                            </Fragment>

                        )}
                    </FormContainer>
                )}
                <div
                    style={{ margin: "10px 0", borderTop: "1px solid lightgray" }}
                ></div>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    {
                        reset && (
                            <FormButton
                                title="Save"
                                type="primary"
                                size={BUTTON_SIZE}
                                colSpan={2}
                                htmlType="button"
                                onClick={handleSave}
                                icon={<SaveOutlined />}
                            />
                        )
                    }
                </div>
                {formPanel && !hideAddButton && (

                    FeatureExists(FeatureArray, "add") && (
                        <Row style={{ flexDirection: "row-reverse" }}>
                            <FormButton
                                type="primary"
                                icon={<PlusOutlined />}
                                title="Add New"
                                size={BUTTON_SIZE}
                                color="#01C2A6"
                                onClick={() => {
                                    onFormOpen && onFormOpen();
                                    setVisible(true);
                                    setIsUpdate(false);
                                }}
                            />
                        </Row>
                    )
                )}

                {tableColumn && (
                    <div style={{ margin: "10px 0" }}>
                        <Table
                            columns={tableColumn}
                            rowKey={(record) => record[actionID]}
                            dataSource={tableRows}
                            className="no-broder-row"
                            pagination={paginationConfig || {
                                current: 1,
                                pageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100'],
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                            loading={tableLoading}
                            size={TABLE_SIZE}
                            onChange={handlePagination}
                        // sorter={(a, b) => // console.log(a, b)}
                        />
                    </div>
                )}
            </div>
            <FormModal
                visible={visible}
                onClose={closeForm}
                width={formWidth}
                className="formModalContainer"
                footer={modalFooter}
                title={`${isUpdate ? "Update" : "New"} ${crudTitle ? crudTitle : formTitle}`}
                formComponent={
                    disableForm ? (
                        formInnerComponent
                    ) : (
                        <FormContainer
                            rowStyle={{ paddingTop: 20 }}
                            onSubmit={handleFormSubmit}
                        >
                            {formInnerComponent}
                        </FormContainer>
                    )
                }
            />
        </div>
    );
};

BasicModalFormComponent.propTypes = {
    formWidth: string,
    formTitle: string,
    searchPanel: element,
    searchSubmit: func,
    formPanel: element,
    tableLoading: bool,
    tableRows: array,
    tableColumn: array,
    onFormSave: func,
    isCancel: bool,
    onCancel: func,
    hideAction: bool,
    hideEdit: bool,
    hideDelete: bool,
    actionID: string,
    editRow: func,
    deleteRow: func,
    formLoading: bool,
    onUpdate: func,
    onFormClose: func,
    onFormOpen: func,
    hideAddButton: bool,
    crudTitle: string,
    showSubmit: bool,
    submitForm: func,
    submitFormLoading: bool,
    disableSaveAndSubmit: bool,
    disableForm: bool,
    report: bool,
    viewReport: func,
    componentRefPrint: func,
};

export default BasicModalFormComponent;
